import { makeStyles } from "@material-ui/core/styles";

export function useAttendanceLocalExpedientStyles() {
  const useStyles = makeStyles((theme) => ({
    button: {
      color: "#004B97",
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 500,
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    cardHeader: {
      color: "#fff",
      backgroundColor: "#004B97",
    },
    cardContent: {
      display: "flex",
    },
    cardActions: {
      justifyContent: "flex-end",
      borderTop: "1px solid #F0F0F0",
    },
    tableContainer: {
      borderRadius: 5,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "#E0E0E0",
      "& tbody tr:last-child td": {
        borderBottom: "none",
      },
      maxWidth: "100vw",
      overflowX: "auto",
    },
    tableTH: {
      color: "#706E7A",
      backgroundColor: "#F5F5F5",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
